import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=09b898f0&scoped=true&"
import script from "./orderStatistics.vue?vue&type=script&lang=js&"
export * from "./orderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./orderStatistics.vue?vue&type=style&index=0&id=09b898f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b898f0",
  null
  
)

export default component.exports